import { render } from "./DeleteUniversity.vue?vue&type=template&id=6019d38d&scoped=true"
import script from "./DeleteUniversity.vue?vue&type=script&lang=js"
export * from "./DeleteUniversity.vue?vue&type=script&lang=js"

import "../css/DeletingList.css?vue&type=style&index=0&id=6019d38d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6019d38d"]])

export default __exports__